import React from 'react'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import { getPlural } from 'lib/string/pluralize'

interface Props {
  saleUnit: string
}

function PreSelectionBanner({ saleUnit }: Props) {
  return (
    <MessageBanner
      kind="promotional-primary"
      density="compact"
    >
      We've pre-selected the best-value {getPlural(saleUnit)} to get you started. Customise each {saleUnit} below.
    </MessageBanner>
  )
}

export default PreSelectionBanner
